module.exports = __webpack_public_path__ + "img/recover-success-v1.3d29b0aa.png";